import { formatDistanceToNowStrict, format } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import { getProfileMeta, getStatusMeta } from '@services/userManagementService'

const PERMISSION_LABELS = {
  'users.view': 'Usuários',
  'users.list': 'Listar usuários',
  'users.create': 'Criar usuários',
  'users.edit': 'Editar usuários',
  'board.view': 'Visualizar Kanban',
  'dashboard.view': 'Visualizar Dashboard Performance',
  'reports.view': 'Visualizar Relatórios',
  'reports.processes.view': 'Visualizar Relatórios por cliente',
  'reports.clickbus.view': 'Visualizar Relatório ClickBus',
  'simulator.view': 'Usar Simulador de Prazos',
  'simulator.settings.manage': 'Configurar Simulador',
  'templates.manage': 'Modelos de peças',
  'forms.view': 'Visualizar Fichas RH',
  'portal.view': 'Acessar Adjutorem IA',
  'users.manage': 'Gerenciar usuários e perfis (legado)',
  'system.manage': 'Gerenciar sistema',
  'publications.manage': 'Gerenciar publicações',
  'deadline.manage': 'Gerenciar prazos',
  'forms.manage': 'Gerenciar formulários',
}

export function getInitials(name = '') {
  return name
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join('')
}

export function formatDateTime(value) {
  if (!value) return 'Nunca acessou'
  return format(new Date(value), "dd/MM/yyyy 'às' HH:mm", { locale: ptBR })
}

export function formatRelativeAccess(value) {
  if (!value) return 'Sem acesso registrado'
  return `${formatDistanceToNowStrict(new Date(value), { addSuffix: true, locale: ptBR })}`
}

export function getProfileLabel(profile) {
  return getProfileMeta(profile)?.label || profile
}

export function getStatusLabel(status) {
  return getStatusMeta(status)?.label || status
}

export function getPermissionLabel(permission) {
  return PERMISSION_LABELS[permission] || permission
}
